import {defineStore} from 'pinia';
import {ModuleAVACheckSpell} from '../moduleConst';
import {useContextStore} from '../contextStore';
import avaPlatformApi from '@/apis/avaPlatform/avaPlatformApi';
export const useAvaCheckSpellStore = defineStore(ModuleAVACheckSpell, {
  state: () => ({
    wordNotCorrected: [],
  }),
  actions: {
    /**
     * Kiểm tra chính tả
     * pntoan 16.4.2024
     */
    async spellCheck(sentence) {
      const context = useContextStore();

      let avaConnectInfoStr = context.$state.context.AVAConnectInfo ? context.$state.context.AVAConnectInfo : null;

      let avaConnectInfo = JSON.parse(avaConnectInfoStr);

      if (!avaConnectInfo || !avaConnectInfo.token) {
        let data = await avaPlatformApi.refreshAVAConnect();

        if (data) {
          const contextStore = useContextStore();
          let context = contextStore.$state.context;
          context.AVAConnectInfo = JSON.stringify(data);

          avaConnectInfo = data;
        }
      }

      const payload = {
        sentence: sentence,
        token: avaConnectInfo.token,
        subScriberNo:
          context.$state.context && context.$state.context.Context && context.$state.context.Context.SubscriberNo
            ? context.$state.context.Context.SubscriberNo
            : '', // bổ sung thông tin monitor
      };

      let result = await avaPlatformApi.spellCheck(payload);

      // Lọc ra những giá trị sai từ AVA ví dụ như ngày tháng AVA đang trả ra sai
      if (result?.length > 0) {
        result = Array.from(result).filter(e => {
          // Nếu từ đó chỉ có 1 cách sửa và cách sửa đó lower case đi = giá trị cũ tức là từ đó không sai
          if (e.correctWord?.length == 1 && e.word.toLowerCase() == e.correctWord[0].toLowerCase()) {
            return false;
          }
          return true;
        });
        this.wordNotCorrected = result;
      }
      return result;
    },

    /**
     * Kết nối AVA
     * @returns
     * nhhoang1 16.05.2024
     */
    async refreshConnection() {
      let data = await avaPlatformApi.refreshAVAConnect();

      if (data) {
        const contextStore = useContextStore();
        let context = contextStore.$state.context;
        context.AVAConnectInfo = JSON.stringify(data);

        return data;
      } else {
        showError('Đã có lỗi xảy ra, vui lòng liên hệ MISA để được hỗ trợ.');
      }
    },
  },
  getters: {},
});
